import styled from 'styled-components';
export const Wrapper = styled.div `
  border-radius: 12px;
  max-height: 100%;
  min-width: 602px;
  max-width: 100%;
  display: flex;
  flex-direction: column;

  && * {
    font-family: 'DM Sans', sans-serif;
  }

  @media (max-width: 768px) {
    & {
      height: 100%;
      width: auto;
      min-width: unset;
    }
  }
`;
export const LoaderWrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 265px;
  width: 100%;
  @media (max-width: 768px) {
    height: 100%;
  }
`;
